<template>
  <form>
    <div>
      <button
        v-if="!newArt"
        class="button is-success mb-10"
        :class="{'is-loading': saving}"
        @click.prevent="saveArt"
      >
        Save changes
      </button>
    </div>
    <div class="frow gutters mb-20">
      <div class="col-sm-1-2">
        <div class="file has-name is-boxed">
          <label
            class="file-label"
            for="image"
          >
            <input
              id="image"
              class="file-input"
              type="file"
              @change="uploadImage"
            >
            <span class="file-cta">
              <br>
              <span class="file-icon">
                <i class="fas fa-file-image fa-3x" />
              </span>
              <br>
              <span class="file-label">
                Upload Image
              </span>
            </span>
          </label>
        </div>
        <div v-if="art.image || art.uploadedImageUrl || newArtImage">
          <img :src="imageURL">
        </div>
        <div
          v-if="art.embed"
        >
          <div
            class="notification is-link is-light"
          >
            <strong>Using Embed</strong>
          </div>
          <div v-html="art.embed" />
        </div>
      </div>
    </div>
    <div class="frow gutters">
      <div class="col-sm-1-2">
        <div class="field">
          <label
            class="label"
            for="imageTitle"
          >
            Title
          </label>
          <input
            id="imageTitle"
            v-model="art.title"
            class="input"
            name="imageTitle"
            type="text"
          >
        </div>
      </div>
      <div class="col-sm-1-2">
        <div class="field">
          <label
            class="label"
            for="link"
          >
            Link
          </label>
          <input
            id="link"
            v-model="art.link"
            class="input"
            name="link"
            type="text"
          >
        </div>
      </div>
      <div class="col-sm-1-2 mt-10">
        <div class="field">
          <label
            class="label"
            for="date"
          >
            Date
          </label>
          <input
            id="date"
            v-model="art.date"
            class="input"
            name="date"
            type="date"
          >
        </div>
      </div>
      <div class="col-sm-1-2 mt-10">
        <div class="field">
          <label
            class="label"
            for="external-link"
          >
            External Link
          </label>
          <input
            id="external-link"
            v-model="art.externalLink"
            class="input"
            name="external-link"
            type="external-link"
          >
        </div>
      </div>
    </div>
    <div class="frow gutters">
      <div class="col-md-1-2">
        <div class="field">
          <label
            class="checkbox reset frow mt-20 ml-10"
          >
            <div class="frow justify-start">
              <input
                v-model="art.hidden"
                type="checkbox"
              >
              hide from Image Bank
            </div>
          </label>
        </div>
        <div class="field">
          <label
            class="checkbox reset frow ml-10"
          >
            <div class="frow justify-start">
              <input
                v-model="art.categoryOnly"
                type="checkbox"
              >
              show in category only
            </div>
          </label>
        </div>
      </div>
      <div class="col-sm-1-2 mt-10">
        <div class="field">
          <label
            class="label"
            for="alt-tag"
          >
            Image Alt Tag
          </label>
          <input
            id="alt-tag"
            v-model="art.altTag"
            class="input"
            name="alt-tag"
            type="alt-tag"
          >
        </div>
      </div>
      <div class="col-md-1-2">
        <div class="field mt-20">
          <label
            class="label"
            for="imageDescription"
          >
            Embed
          </label>
          <textarea
            v-model="art.embed"
            class="textarea"
          />
          <small>NOTE: Using embed code will use any artwork that is attatched as the thumbnail in the image bank</small>
        </div>
      </div>
    </div>
    <div class="field">
      <label
        class="label"
        for="imageDescription"
      >
        Description
      </label>
      <wysiwyg
        v-model="art.description"
        class="wysiwyg"
      />
    </div>
    <div class="field ml-10">
      <label
        class="label"
        for="imageDescription"
      >
        TAGS
      </label>
      <div class="frow column-start tags">
        <label
          v-for="tag in tags"
          :key="tag"
          class="checkbox reset col-md-1-4 frow"
        >
          <div class="frow justify-start">
            <input
              v-model="art.tags"
              :value="tag"
              type="checkbox"
            >
            {{ tag }}
          </div>
        </label>
      </div>
      <div class="field">
        <div class="frow gutters">
          <div class="col-md-1-2">
            <label class="label">
              STORY
            </label>
            <multiselect
              v-model="parentStory"
              :options="stories"
              label="title"
              track-by="title"
            />
            <!-- <div class="select">
              <select v-model="parentStory">
                <option :value="null">
                  None
                </option>
                <option
                  v-for="s in stories"
                  :key="s.id"
                  :value="s"
                >
                  {{ s.title }}
                </option>
              </select>
            </diiv> -->
          </div>
        </div>
      <!-- <div
        v-if="selectedArt"
        class="frow row-start mt-20"
      >
        <strong>Link:&nbsp;</strong> {{ generatedLink }}
      </div>
    </div> -->
      </div>
      <StoryReferences
        :active-art="art"
        :stories="stories"
      />
      <button
        v-if="!newArt"
        class="button is-success is-pulled-right mt-20"
        :class="{'is-loading': saving}"
        @click.prevent="saveArt"
      >
        Save changes
      </button>
    </div>
  </form>
</template>

<script>
import { mapState } from 'vuex';
import StoryReferences from '@/components/StoryReferences.vue';

export default {
  name: 'ArtForm',
  components: {
    StoryReferences,
  },
  props: {
    art: {
      type: Object,
      default: () => {},
    },
    newArt: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saving: false,
      saveNewArt: false,
      newImage: null,
      newArtImage: null,
      linkTitle: '',
      stories: [],
      parentStory: null,
      tags: null,
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.profile.user,
      jwt: (state) => state.profile.jwt,
    }),
    API() {
      return this.$API;
    },
    imageURL() {
      if (this.newArtImage) {
        return this.newArtImage;
      }
      if (process.env.NODE_ENV === 'development') {
        if (this.art.uploadedImageUrl) {
          return `${this.API}${this.art.uploadedImageUrl}`;
        }
        return `${this.API}${this.art.image.url}`;
      }
      if (this.art.uploadedImageUrl) {
        return `${this.art.uploadedImageUrl}`;
      }
      return `${this.art.image.url}`;
    },
  },
  watch: {
    art: function() {
      this.setActiveParent();
    },
  },
  mounted() {
    this.getStories();
    this.setActiveParent();
    this.getSettings();
  },
  methods: {
    getSettings() {
      this.axios.get(`${this.$API}/settings`).then((response) => {
        this.tags = response.data[0].categories;
      });
    },
    saveArt() {
      const method = this.newArt ? 'POST' : 'PUT';
      const url = this.newArt ? `${this.$API}/arts/` : `${this.$API}/arts/${this.art.id}`;

      const data = this.art;
      if (this.art.uploadedImageUrl) {
        delete data.image;
        delete data.uploadedImageUrl;
      }
      if (this.parentStory) {
        data.stories = [this.parentStory.id];
      } else {
        data.stories = [];
      }

      this.axios({
        method,
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
        data,
        url,
      })
        .then((response) => {
          if (response.status === 200) {
            if (this.newArt) {
              this.art = response.data;
              this.saveNewArt = true;
              this.uploadImage(this.newImage);
            }
            this.$emit('saved');
            this.$snotify.success(`${this.art.title} saved`,'Success');
          }
        })
        .catch((err) => {
          console.log(err);
          this.$snotify.error(err, 'Saving failed', {
            timeout: 10000,
            showProgressBar: false,
          });
        });
    },
    setActiveParent() {
      this.parentStory = null;
      if (this.art.stories && this.art.stories.length > 0) {
        this.parentStory = this.stories.find((s) => s.id === this.art.stories[0].id);
      }
    },

    uploadImage(e) {
      if (e === null) {
        console.warn('No Image');
        return;
      }
      if (this.newArt && this.saveNewArt === false) {
        this.newImage = e;
        const selectedFile = e.target.files[0];
        const reader = new FileReader();
        reader.onload = (event) => {
          this.newArtImage = event.target.result;
        };

        reader.readAsDataURL(selectedFile);
      } else {
        const body = new FormData();

        body.append('refId', this.art.id);
        body.append('ref', 'art');
        body.append('field', 'image');
        body.append('files', e.target.files[0]);

        const request = new XMLHttpRequest();

        request.onreadystatechange = () => {
          if (request.readyState === XMLHttpRequest.DONE) {
            this.$set(this.art, 'uploadedImageUrl', JSON.parse(request.response)[0].url);
          }
        };

        request.open('POST', `${this.$API}/upload`);
        request.setRequestHeader('Authorization', `Bearer ${this.jwt}`);
        request.send(body);
      }
    },
    getStories() {
      this.axios.get(`${this.$API}/stories-stripped-with-description?_sort=title:ASC`).then((response) => {
        this.stories = response.data;
        if (this.art.stories) {
          this.parentStory = this.stories.find((s) => s.title === [this.art.stories].title);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
form {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 700px;
}
label {
  text-align: left;
}
select {
  background-image: none;
}
.card {
  margin: 1px;
  // text-align: left;
}
img {
  max-height: 200px;
}
.file-cta {
  margin: auto;
  max-width: 120px;
}
.tags {
  height: 400px;
}
.wysiwyg {
  // text-align: left;
}
</style>
